export interface ActivityDescription {
    formatString: string;
    plainText: string;
    people: Array<ActivityPerson>;
    reasonType: ActivityReason;
    timestamp: Date;
}

export interface ActivityPerson {
    upn: string;
    tag: string;
    name: string;
}

export enum ActivityReason {
    None,
    Default,
    Open,
    Edit,
    Comment,
    Mention,
    Share,
    Attachment,
    SnoozeExpiry,
    Trending,
    News,
    Meeting,
    Video,
    MyAnalytics,
    Task
}
